export const formatPrecio = (value, usarComa = false, forceTwoDecimals = false) => {
  const num = Number(value);
  if (!Number.isFinite(num)) {
    return usarComa ? '0,00' : '0.00';
  }

  const decimals = forceTwoDecimals ? 2 : (Number.isInteger(num) ? 0 : 2);
  const fixed = num.toFixed(decimals);
  let [integerPart, decimalPart = ''] = fixed.split('.');

  // Separador de miles: punto si el decimal es coma, y viceversa.
  if (usarComa) {
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  } else {
    // Si usamos punto para decimal, no separamos miles para evitar ambigüedad (ej. 1.234.56).
    // Opcional: podríamos usar coma aquí si el formato regional lo requiere.
  }

  const hasDecimals = decimals > 0 && (forceTwoDecimals || Number(decimalPart) !== 0);
  if (!hasDecimals) {
    return integerPart;
  }

  const decimalSeparator = usarComa ? ',' : '.';
  return `${integerPart}${decimalSeparator}${decimalPart}`;
};

export const formatPrice = (value, options = {}) => {
  if (typeof options === 'boolean') {
    return formatPrecio(value, options);
  }

  const {
    useCommaDecimal = false,
    forceTwoDecimals = useCommaDecimal,
  } = options;

  const num = Number(value);
  if (!Number.isFinite(num)) {
    return useCommaDecimal ? '0,00' : '0.00';
  }

  const decimals = forceTwoDecimals ? 2 : (Number.isInteger(num) ? 0 : 2);
  const fixed = num.toFixed(decimals);
  let [integerPart, decimalPart = ''] = fixed.split('.');

  // Separador de miles: punto si el decimal es coma, y viceversa.
  if (useCommaDecimal) {
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  } else {
    // Opcional: si el decimal es punto, podríamos usar coma para miles, pero
    // por ahora lo dejamos sin separador para evitar confusión.
  }
  const hasDecimals = decimals > 0 && (forceTwoDecimals || Number(decimalPart) !== 0);
  if (!hasDecimals) {
    return integerPart;
  }

  const decimalSeparator = useCommaDecimal ? ',' : '.';
  return `${integerPart}${decimalSeparator}${decimalPart}`;
};

export default formatPrecio;
